import {Message} from '@mui/icons-material';
import {FeatureObject} from '../../../types/FeatureObject';
import {FeatureStatus} from '../../../types/FeatureStatus';
import ContactMessages from './ContactMessages';

export const contactMessages: FeatureObject = {
  type: 'settings',
  title: 'Contact Messages',
  description: 'View contact messages and support requests (admin only)',
  path: '/settings/contact-messages',
  component: (user) => <ContactMessages user={user} />,
  IconComponent: Message,
  status: FeatureStatus.ADMIN,
  tags: [],
  permission: 'owner',
};
